import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IAssetsFormMeta {
    assetDescription: FormInputMeta;
    accountNumber: FormInputMeta;
    accountName: FormInputMeta;
    debt: FormInputMeta;
    value: FormInputMeta;
    schema: any;
  }

const AssetsFormMeta = {} as IAssetsFormMeta;

AssetsFormMeta.assetDescription = {
    label: 'Description des capitaux',
    name: 'assetDescription',
    type: 'select',
    placeholder: 'Select ...',
    options:  [
      {
        label: 'Asset 1',
        value: '1'
      },
      {
        label: 'Asset 2',
        value: '2',
      },
      {
        label: 'Asset 3',
        value: '3',
      },
    ],   
    validation: yup.string().required(),
}

AssetsFormMeta.accountNumber = {
    label: 'Num Compte',
    name: 'accountNumber',
    type: 'text',
    placeholder: '',    
    validation: yup.string().required(),
}
AssetsFormMeta.accountName = {
  label: 'Nom dans lequel le compte est porté',
  name: 'accountName',
  type: 'text',
  placeholder: '',    
  validation: yup.string().required(),
}
AssetsFormMeta.debt = {
  label: 'Sujet à la dette',
  name: 'debt',
  type: 'checkbox',
  placeholder: '',    
  validation: yup.string().required(),
}
AssetsFormMeta.value = {
  label: 'Valeur',
  name: 'value',
  type: 'number',
  placeholder: '',    
  validation: yup.string().required(),
}



AssetsFormMeta.schema = yup.object().shape(getValidationSchema(AssetsFormMeta));

export default AssetsFormMeta;